import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrCD: CultureInfo = {
  name: 'fr-CD',
  displayName: 'French (Congo - Kinshasa)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-CD',
  parent: CultureInfoFr
};
